import './components/header';
import './components/nav';
import './components/totop';
import './components/sticky';
import './components/carousel';
import './components/rating';
import './fe';
import './be';